module.exports = function() {
  return new Worker(__webpack_public_path__ + "8ee00684417e7d352f2e.worker.js");
};